@if (data) {
  <div>
    @for(element of data.all_study_elements; track element) {
      <div class="mb-4">
        <ul class="list-disc text-black pl-5">
          <li>
            <h3 class="text-lg font-semibold text-gray-900 mb-1">Element Name: {{ element.name }}</h3>
            <div class="px-4">
              <p class="text-gray-800"><strong>Description : </strong> {{ element.description }}</p>
              <p class="text-gray-800"><strong>Start :</strong> {{ element.start_rule }}</p>
              <p class="text-gray-800"><strong>End :</strong> {{ element.end_rule }}</p>
            </div>
          </li>
        </ul>
      </div>
    }
  </div>
}
